var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7083 13.75V18.3333H24.2917V13.75H19.7083ZM18.7917 11C17.7791 11 16.9583 11.8208 16.9583 12.8333V19.25C16.9583 20.2625 17.7791 21.0833 18.7917 21.0833H25.2083C26.2209 21.0833 27.0417 20.2625 27.0417 19.25V12.8333C27.0417 11.8208 26.2209 11 25.2083 11H18.7917ZM13.75 25.6667V30.25H18.3333V25.6667H13.75ZM12.8333 22.9167C11.8208 22.9167 11 23.7375 11 24.75V31.1667C11 32.1792 11.8208 33 12.8333 33H19.25C20.2625 33 21.0833 32.1792 21.0833 31.1667V24.75C21.0833 23.7375 20.2625 22.9167 19.25 22.9167H12.8333ZM25.6667 30.25V25.6667H30.25V30.25H25.6667ZM22.9167 24.75C22.9167 23.7375 23.7375 22.9167 24.75 22.9167H31.1667C32.1792 22.9167 33 23.7375 33 24.75V31.1667C33 32.1792 32.1792 33 31.1667 33H24.75C23.7375 33 22.9167 32.1792 22.9167 31.1667V24.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/pricing-icon.31e6784af23fe33d1ef0c6528d8c5fe0.svg";
export { ForwardRef as ReactComponent };